import Icon from "../../../../../assets/spaceicons/radio.svg";
import {
  SpaceComponentPackage,
  SpaceComponentHostType,
  SpaceComponentTags
} from "../../../../../types";
import { DEFAULT_SIZES } from "../../../layout/constants";
import { ElementLayout, LayoutUnit } from "../../../layout/util";

import Config, { InlineConfig, TerseConfig } from "./Config";
import errorSelector from "./Config/errorSelector";
import componentConfigReducer, {
  ensureSpaceRadioButtonComponent,
  getComponentProperties,
  makeInitialState,
  RadioButtonConfigState
} from "./Config/reducer";
import { getSchema } from "./getSchema";
import SpaceRadioButton from "./SpaceRadioButton";
import { SpaceRadioButtonComponent, SpaceRadioButtonProperties } from "./types";

const pkg: SpaceComponentPackage<
  SpaceRadioButtonProperties,
  SpaceRadioButtonComponent,
  RadioButtonConfigState
> = {
  type: "RADIO_BUTTON",
  displayName: "Radio Button",
  Icon,
  allowedHosts: new Set<SpaceComponentHostType>([
    "SPACE",
    "TABLE",
    "DETAIL",
    "CARD_LIST",
    "FUNCTION_FORM",
    "FUNCTION_MODAL_FORM",
    "FLEX_BOX",
    "CLOUD_UPLOADER"
  ]),
  Component: SpaceRadioButton,
  ConfigurationComponent: Config,
  TerseConfigurationComponent: TerseConfig,
  InlineConfigurationComponent: InlineConfig,
  componentConfigReducer,
  getInitialDraftState: makeInitialState,
  ensureComponent: ensureSpaceRadioButtonComponent,
  getComponentProperties,
  getSchema,
  defaultElementLayout: new ElementLayout({
    width: DEFAULT_SIZES.INPUT.width,
    height: LayoutUnit.AUTO,
    snapToGrid: false
  }),
  allowSelfBinding: true,
  allowAncestorBinding: true,
  tags: [SpaceComponentTags.Input],
  isHeadless: false,
  errorSelector,
  isContainer: false
};

export default pkg;
